import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { loginUser } from '../api/auth';
import { setAuthenticated } from '../storage';
import PasswordField from './PasswordField';

const LoginForm = () => {
    const [emailOrUsername, setEmailOrUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true);

        try {
            const response = await loginUser(emailOrUsername, password);
            setAuthenticated(response.user.user_id);
            history.push('/dashboard');
        } catch (err) {
            if (err.error_code === 'EMAIL_NOT_CONFIRMED') {
                setError('Please verify your email address before logging in. Check your inbox for the confirmation link.');
            } else {
                setError(err.message || 'Login failed');
            }
            setIsSubmitting(false);
        }
    };

    return (
        <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="sc-alert sc-alert--error" role="alert">{error}</div>}

            <div className="auth-field">
                <label htmlFor="emailOrUsername">Email or username</label>
                <input
                    type="text"
                    id="emailOrUsername"
                    value={emailOrUsername}
                    onChange={(e) => setEmailOrUsername(e.target.value)}
                    placeholder="Email or username"
                    autoComplete="username"
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    required
                    disabled={isSubmitting}
                />
            </div>

            <PasswordField
                id="password"
                name="password"
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Your password"
                autoComplete="current-password"
                disabled={isSubmitting}
            />

            <button type="submit" className="sc-btn sc-btn--primary sc-btn--block" disabled={isSubmitting}>
                {isSubmitting ? 'Signing in...' : 'Sign in'}
            </button>

            <p className="auth-footer">
                New to SpudClub? <Link to="/register">Create an account</Link>
            </p>
        </form>
    );
};

export default LoginForm;
